import PropTypes from "prop-types";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Grid from "@mui/material/Grid";

function Layout({ title, activeTab, onTabChange, children }) {
  return (
    <MKBox
      width="100%"
      position="relative"
      borderRadius="xl"
      shadow="lg"
      mb={12}
      sx={{ overflow: "hidden" }}
    >
      <MKBox
        px={3}
        sx={{
          borderBottom: ({ borders: { borderWidth, borderColor } }) =>
            `${borderWidth[1]} solid ${borderColor}`,
        }}
      >
        <Grid container spacing={2} justifyContent="space-between" py={1}>
          <Grid item xs={12} lg={3}>
            <MKTypography variant="body1" pt={0.5}>
              {title}
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={3}>
            <AppBar position="static">
              <Tabs value={activeTab} onChange={(event, newValue) => onTabChange(newValue)}>
                <Tab label="대리점 신청서" />
                <Tab label="협업 신청서" />
              </Tabs>
            </AppBar>
          </Grid>
        </Grid>
      </MKBox>
      <MKBox width="100%" p={3}>
        <MKBox
          bgColor="grey-100"
          width="100%"
          height="auto"
          maxHeight="40rem"
          borderRadius="xl"
          sx={{ overflowX: "hidden", overflowY: "scroll" }}
        >
          {children}
        </MKBox>
      </MKBox>
    </MKBox>
  );
}

Layout.propTypes = {
  title: PropTypes.string.isRequired,
  activeTab: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default Layout;
